// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { LMRefreshRequest, LMDetailSectionBase } from '@app/components';

@Component({
  selector: 'lm-detail-section-notfound',
  standalone: false,
  template: `
    @if (activated) {
      <div>
        <p>{{'UnsupportedListDetailSectionType' | translate}}</p>
      </div>
    }
    `
})
export class LMDetailSectionNotFoundComponent implements LMDetailSectionBase {
  @Input()
  set activated(activated: boolean) {
    this._activated = activated;
  }

  get activated() {
    this.detailSectionDisplayed.emit(this);
    return this._activated;
  }

  @Output() detailSectionDisplayed = new EventEmitter<any>();

  private _activated;

  needsReload: boolean;
  fromDataView: LMDataView;
  type: string;

  constructor() {}

  isModified(): boolean {
    return false;
  }

  saveDetailSectionState() {
    // noop
  }

  clearDetailSectionState() {
    // noop
  }

  save(callBack: Observer<boolean>) {
    // nothing to save
    callBack.next(true);
    callBack.complete();
  }

  refresh(request: LMRefreshRequest): Observable<boolean> {
    return of(true);
  }
}
